import React from 'react'

import useUserSignedIn from 'modules/user/useUserSignedIn'
import { Children, renderConditionally } from 'utils/renderConditionally'

interface SignedInProps {
  children: Children
}

export const IsNotSignedIn: React.FC<SignedInProps> = ({ children }) => (
  <>{renderConditionally(children, !useUserSignedIn())}</>
)

export const IsSignedIn: React.FC<SignedInProps> = ({ children }) => (
  <>{renderConditionally(children, useUserSignedIn())}</>
)
